module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" volume is somewhat ‘off’ the ‘beaten track’ of books on Trees, and the author believes that it will be found to contain a considerable amount of information of a kind that will be new even to usually well-informed readers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Happily the study of nature-subjects generally is now very much in evidence, and the recognition by our educational authorities of the importance of nature-teaching will keep the minds of the rising generation in a very desirable groove.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An alphabetical arrangement of the contents of this volume has been adopted for the easy reference of the reader; and the chapter on Indigenous British Trees and Shrubs, giving names, heights, time of flowering, and colours of flowers, should prove to be a useful novelty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Glossarial Index will show at a glance the extent of the information laboriously gathered together; but it has been a genuine ‘labour of love.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANCIS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EATH")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65a302c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/pre.vue
// module id = 66
// module chunks = 0